import { render, staticRenderFns } from "./TraduccionChat.vue?vue&type=template&id=3fe33dae&lang=pug&"
import script from "./TraduccionChat.vue?vue&type=script&lang=js&"
export * from "./TraduccionChat.vue?vue&type=script&lang=js&"
import style0 from "./TraduccionChat.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports